import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { t } from "i18next";

import { useLazyGetPublicDataFileQuery } from "@/redux/service";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";

import "./styles.css";

const PublicFile = () => {
  const { uuid } = useParams();

  const [getPublicDataFile, publicFileResponse] =
    useLazyGetPublicDataFileQuery();

  useEffect(() => {
    if (uuid) {
      getPublicDataFile(uuid);
    }
  }, [uuid]);

  useEffect(() => {
    if (publicFileResponse.isSuccess) {
      window.location.href = publicFileResponse.data.link;
    }
  }, [publicFileResponse]);

  return (
    <div className="public-file-container">
      <BaseSpinner />

      {publicFileResponse.data?.link && (
        <span className="body-m-regular">
          <span>{t("labels.havingTroublePart1")}</span>
          <Link
            to={publicFileResponse.data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("labels.here")}
          </Link>
          <span>{t("labels.havingTroublePart2")}</span>
        </span>
      )}
    </div>
  );
};

export default PublicFile;
